import React from 'react';

import { flagStyles } from '../settings';

const SvgKG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2736px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKG;
